<template>
    <div
        class="bodybox"
        id="jiaoanx"
        style="padding:0.1px"
        oncontextmenu="return false"
        onselectstart="return false"
        ondragstart="return false"
    >
        <div id="app" style="padding:8px 15px 0">
            <input type="hidden" id="reid" :value="re_id" />
            <div class="container-fluid">
                <div class="row">
                    <div class="col-sm-4" style="padding: 0;height: 100%;">
                        <div class="fix">
                            <div class="btn-group" style="width: 32%;float: left">
                                <button
                                    type="button"
                                    class="btna dropdown-toggle kezhuang1"
                                    data-toggle="dropdown"
                                    style="width: 100%"
                                >
                                    课程系列
                                </button>
                            </div>
                            <div class="btn-group" style="width: 32%;;margin-left: 2%;float: left">
                                <button
                                    type="button"
                                    class="btna dropdown-toggle kezhuang1"
                                    data-toggle="dropdown"
                                    style="width: 100%"
                                >
                                    全部课程
                                    <!--<span class="caret"></span>-->
                                </button>
                            </div>
                            <div class="btn-group" style="width: 32%;float: right">
                                <button
                                    type="button"
                                    class="btna dropdown-toggle kezhuang2"
                                    data-toggle="dropdown"
                                    style="width: 100%"
                                >
                                    <span>全部教案</span>
                                    <!--<span class="caret"></span>-->
                                </button>
                            </div>
                        </div>
                        <div class="fix">
                            <div style="width: 32%;float: left" v-if="quanke3">
                                <el-menu :default-active="activeIndex1"  class="el-menu-vertical-demo">
                                    <el-submenu index="10">
                                        <template slot="title">
                                            <!--<i class="el-icon-location"></i>-->
                                            <span>托育</span>
                                        </template>
                                        <el-menu-item
                                                v-for="(titem,tindex) in tuoyu"
                                                :key="tindex"
                                                :index="'10-'+titem.kc_id"
                                                @click="ke3(titem.classa,1,titem.kc_id)">
                                            <template slot="title">{{titem.classa}}</template>
                                        </el-menu-item>
                                    </el-submenu>
                                </el-menu>
                                <el-menu :default-active="activeIndex2" class="el-menu-vertical-demo">
                                    <el-submenu index="11">
                                        <template slot="title">
                                            <!--<i class="el-icon-location"></i>-->
                                            <span>早教</span>
                                        </template>
                                        <el-menu-item
                                                v-for="(zitem,zindex) in zaojiao"
                                                :key="zindex"
                                                :index="'11-'+zitem.kc_id"
                                                @click="ke3(zitem.classa,2,zitem.kc_id)">
                                            <template slot="title">{{zitem.classa}}</template>
                                        </el-menu-item>
                                    </el-submenu>
                                </el-menu>
                                <el-menu :default-active="activeIndex3" class="el-menu-vertical-demo">
                                    <el-submenu index="11">
                                        <template slot="title">
                                            <!--<i class="el-icon-location"></i>-->
                                            <span>增值课程</span>
                                        </template>
                                        <el-menu-item
                                            v-for="(zitem,zindex) in zengzhi"
                                            :key="zindex"
                                            :index="'11-'+zitem.kc_id"
                                            @click="ke3(zitem.classa,3,zitem.kc_id)">
                                            <template slot="title">{{zitem.classa}}</template>
                                        </el-menu-item>
                                    </el-submenu>
                                </el-menu>
                                <!--<div-->
                                        <!--class="kelist hang1"-->
                                        <!--v-for="ke in quanke3"-->
                                        <!--:class="{active1:(ke.classa==classname)}"-->
                                        <!--@click="ke3(ke.classa)"-->
                                        <!--v-cloak-->
                                <!--&gt;{{ke.classa}}</div>-->
                            </div>
                            <div style="width: 32%;float: left;margin-left: 2%" v-if="quanke1">
                                <div
                                    class="kelist hang1"
                                    v-for="ke in quanke1"
                                    :class="{active1:(ke.kc_id==kcid)}"
                                    @click="ke1(ke.kc_id)"
                                    v-cloak
                                >{{ke.title}}</div>
                            </div>
                            <div style="width: 32%;float: right;margin-left: 2%;height: 800px;overflow: auto" v-if="quanke2">
                                <div
                                    class="kelist hang1"
                                    v-for="ke in quanke2"
                                    :class="{active2:(ke.id==iid)}"
                                    @click="ke2(ke.id)"
                                    v-cloak
                                >{{ke.title}}</div>
                            </div>
                        </div>
                        <div style="clear: both"></div>
                    </div>
                    <div class="col-sm-8">
                        <div>
                            <div
                                class="conTitle text-center"
                                style="height: 85px;line-height: 85px;border-radius: 10px;background: #fff;"
                            >
                                <span v-cloak style="font-size: 24px">{{title}}</span>
                                <span style="color: #999;font-size: 12px">
                                    (
                                    <span v-cloak>{{kechengname}}</span>)
                                </span>

                                <button
                                    v-if="is_bk==1"
                                    class="zidBtn zidy"
                                    style="float: right;background: #eee;color: #666;display: none"
                                >完成备课</button>
                                <button
                                    v-if="is_bk!=1"
                                    class="zidBtn zidy"
                                    style="float: right;display: none"
                                    v-on:click="wanb"
                                >完成备课</button>

                                <button
                                    v-if="is_sc==1"
                                    class="zidBtn zidg"
                                    style="float: right;background: #eee;color: #666;display: none"
                                >设置重点</button>
                                <button
                                    v-if="is_sc!=1"
                                    class="zidBtn zidg"
                                    style="float: right;display: none"
                                    v-on:click="shez"
                                >设置重点</button>
                            </div>
                            <div class="container-fluid" >
                                <div class="row" v-if="zongdata.type == 'video'">
                                    <div class="col-sm-12" style="padding: 0;height: 800px;overflow-y: scroll">
                                        <div class="neirong" style="padding: 0 0 25% 0;">
                                            <div class="box_video" style="position: relative"
                                                 v-for="(videoinfo,videoindex) in fendata"
                                                 @click="ship1($event)"
                                                 v-if="videoinfo.process_video"
                                                 :ship="videoinfo.process_video"
                                            >
                                                <span style="font-size:80px;position: absolute;top:35%;left: 43%" class="fa fa-play-circle"></span>
                                                <img v-if="videoinfo.img" :src="videoinfo.img"  />
                                                <img v-if="!videoinfo.img" src="/static/img/cover/default.png" />
                                                <div class="textinfo">
                                                    <p class="lefttext">{{videoinfo.title}}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-if="zongdata.type == 'pdf'">

                                    <div class="col-sm-12" style="padding: 0;padding-right:4px;margin-bottom: 4px">
                                        <div class="fix titleListBox col-sm-4" v-if="zongdata.has_music == 2">
                                            <!--播放音乐-->
                                            <div class="titleList2"
                                                 v-for="(musicinfo,musicindex) in fendata"
                                                 @click="yin1($event)"
                                                 v-if="musicinfo.process_audio_vid"
                                                 :aud="musicinfo.process_audio_vid"
                                                 style="color: #999;"
                                            >
                                                <img src="/static/qmsj/img/music.png" style="width: 22px;margin-right: 3px;"/>
                                                <span style="padding-left:1px" v-if="musicinfo.title">{{musicinfo.title}}</span>
                                                <span style="padding-left:1px" v-if="!musicinfo.title">音乐播放</span>
                                            </div>
                                        </div>
                                        <div class="fix titleListBox col-sm-4" v-if="zongdata.has_video == 2">
                                            <!--播放视频-->
                                            <div class="titleList2"
                                                 v-for="(videoinfo,videoindex) in fendata"
                                                 @click="ship1($event)"
                                                 v-if="videoinfo.process_video"
                                                 :ship="videoinfo.process_video"
                                                 style="color: #999;"
                                            >
                                                <span style="font-size:22px;vertical-align: middle;" class="fa fa-play-circle"></span>
                                                <span style="padding-left:6px" v-if="videoinfo.title">{{videoinfo.title}}</span>
                                                <span style="padding-left:6px" v-if="!videoinfo.title">视频演示</span>
                                            </div>
                                        </div>
                                        <div class="fix titleListBox col-sm-4" v-if="zongdata.has_img == 2">
                                            <!--下载图片-->
                                                <div class="titleList2 col-sm-6" style="color: #999;"
                                                   v-for="(imginfo,imgindex) in fendata"
                                                   v-if="imginfo.img"
                                                   @click="showimg(imginfo.img)"
                                                >
                                                    <span style="padding-left:6px" v-if="imginfo.title">{{imginfo.title}}</span>
                                                    <span style="padding-left:6px" v-if="!imginfo.title">图片素材</span>
                                                </div>
                                        </div>
                                        <div class="fix titleListBox col-sm-4" v-if="zongdata.has_href_file == 2">
                                            <!--展示PDF文件素材-->
                                            <div class="titleList2" style="color: #999;"
                                                 v-for="(fileinfo,fileindex) in fendata"
                                                 v-if="fileinfo.href_file">
                                                <a target="_blank" :href="fileinfo.href_file" style="padding-left:6px" v-if="fileinfo.title">{{fileinfo.title}}</a>
                                                <a target="_blank" :href="fileinfo.href_file" style="padding-left:6px" v-if="!fileinfo.title">文件素材</a>
                                            </div>
                                        </div>
                                        <div style="clear: both"></div>
                                    </div>
                                    <div class="col-sm-12" style="padding: 0;height: 800px;overflow-y: scroll" oncontextmenu="window.event.returnValue=false">
                                        <div class="neirong" style="padding: 0;">
                                            <div style="position: absolute;width: 805px;height: 2550px;z-index: 1039;border: 1px solid #ffffff;"></div>
                                            <!--<iframe :src="zongdata.pdf+'#toolbar=0&view=FitH,top'" style="width: 805px;height: 2540px;overflow-y: hidden;position: absolute" frameborder="0"></iframe>-->
                                            <img v-if="zongdata.title == '目录'" :src="zongdata.imgfile" style="overflow-y: hidden;position: absolute;max-width: 793px;" alt="">
                                            <img v-if="zongdata.title != '目录'" :src="zongdata.imgfile" style="overflow-y: hidden;position: absolute;width: 793px;top:-85px" alt="">
                                            <!--<embed :src="zongdata.pdf+'#toolbar=0&view=FitH,top'" style="width: 805px;height: 2240px;overflow-y: hidden">-->
                                            <!--<iframe :src="'/static/pdf/web/viewer.html?file='+zongdata.pdf+'#toolbar=false'" frameborder="0" style="width: 100%;min-height: 700px;"></iframe>-->
                                        </div>
                                    </div>
                                </div>
                                <div class="row" v-if="zongdata.type == 'text'">
                                    <div
                                        class="col-sm-6"
                                        style="padding: 0;padding-right:4px;margin-bottom: 4px "
                                    >
                                        <div class="fix titleListBox">
                                            <div class="titleList" style="cursor: auto">
                                                <span>开场舞</span>
                                            </div>

                                            <div
                                                class="titleList"
                                                v-on:click="yin1($event)"
                                                v-if="audios"
                                                :aud="audios"
                                                style="color: #999;float: right"
                                            >
                                                <!--<span style="font-size:22px;vertical-align: middle;" class="fa fa-music"></span>-->
                                                <img
                                                    src="/static/qmsj/img/music.png"
                                                    style="width: 22px;margin-right: 3px;"
                                                />
                                                <span style="padding-left:1px ">音乐播放</span>
                                            </div>

                                            <div
                                                class="titleList"
                                                v-on:click="ship1($event)"
                                                v-if="ships"
                                                v-bind:ship="ships"
                                                style="color: #999;float: right"
                                            >
                                                <span
                                                    style="font-size:22px;vertical-align: middle;"
                                                    class="fa fa-play-circle"
                                                ></span>
                                                <span style="padding-left:6px ">视频演示</span>
                                            </div>
                                        </div>
                                        <div style="clear: both"></div>
                                    </div>
                                    <div
                                        class="col-sm-6"
                                        style="padding: 0;padding-left: 4px;margin-bottom: 4px"
                                    >
                                        <div class="fix titleListBox">
                                            <div class="titleList" style="cursor: auto">
                                                <span>再见仪式</span>
                                            </div>

                                            <div
                                                class="titleList"
                                                v-on:click="yin1($event)"
                                                v-if="audioe"
                                                v-bind:aud="audioe"
                                                style="color: #999;float: right"
                                            >
                                                <img
                                                    src="/static/qmsj/img/music.png"
                                                    style="width: 22px;margin-right: 3px;"
                                                />
                                                <span style="padding-left:6px ">音乐播放</span>
                                            </div>

                                            <div
                                                class="titleList"
                                                v-on:click="ship1($event)"
                                                v-if="shipe"
                                                v-bind:ship="shipe"
                                                style="color: #999;float: right"
                                            >
                                                <span
                                                    style="font-size:22px;vertical-align: middle;"
                                                    class="fa fa-play-circle"
                                                ></span>
                                                <span style="padding-left:6px ">视频演示</span>
                                            </div>
                                        </div>
                                        <div style="clear: both"></div>
                                    </div>

                                    <div class="col-sm-12" style="padding: 0">
                                        <div class="neirong" style="padding: 0;">
                                            <!--<div v-html='zhengwen'>-->
                                            <!--</div>-->
                                            <div class="zhengwen" v-for="(fen,index) in fendata">
                                                <div class="fix">
                                                    <p class="title11" style="float: left;" v-if="fen.ja_id>1778 && index>0">
                                                        {{index}}
                                                        <span>.</span>
                                                        {{fen.title}}
                                                    </p>
                                                    <p class="title11" style="float: left;" v-if="fen.ja_id<1779">
                                                        {{index+1}}
                                                        <span>.</span>
                                                        {{fen.title}}
                                                    </p>

                                                    <div
                                                        class="titleList"
                                                        v-on:click="yin1($event)"
                                                        v-if="fen.process_audio_vid"
                                                        v-bind:aud="fen.process_audio_vid"
                                                        style="float: right;color: #999"
                                                    >
                                                        <img
                                                            src="/static/qmsj/img/music.png"
                                                            style="width: 22px;margin-right: 3px;"
                                                        />
                                                        <span>音乐播放</span>
                                                    </div>
                                                    <div style="clear: both;"></div>

                                                    <div
                                                        class="titleList"
                                                        v-on:click="ship1($event)"
                                                        v-if="fen.process_video"
                                                        v-bind:ship="fen.process_video"
                                                        style="float: right;color: #999"
                                                    >
                                                        <span
                                                            style="font-size:22px;vertical-align: middle;"
                                                            class="fa fa-play-circle"
                                                        ></span>
                                                        <span style="padding-left:6px ">视频演示</span>
                                                    </div>
                                                </div>
                                                <div class="neirong11" v-html="fen.process"></div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-sm-12" style="padding: 0">
                                        <div style="padding: 10px 0 20px">
                                            <i style="color:#fdb06a ">
                                                <span class="fa fa-eye"></span>
                                                <span>
                                                    浏览次数
                                                    <span>{{ydrs}}</span> 次
                                                </span>
                                            </i>
                                            <i style="color:#79c4c7">
                                                <span
                                                    class="fa fa-star-o"
                                                    style="padding-left:28px "
                                                ></span>
                                                <span>
                                                    收藏
                                                    <span>{{shouc}}</span>次
                                                </span>
                                            </i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--视频播放模态框-->
        <div
            class="modal fade"
            id="myModal"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            style="background:rgba(0,0,0,0.3) "
        >
            <div class="modal-dialog" role="document"  :style="ship_style">
                <div class="modal-content">
                    <div class="modal-body" style="padding: 5px;">
                        <div
                            aria-hidden="true"
                            v-on:click="guans"
                            style="float: right;cursor: pointer;font-size:28px;"
                        >&times;</div>
                        <div style="clear: both;"></div>
                        <div style="margin-top: 0;">
                            <div id="myVideo"></div>
                        </div>
                        <!--<video id="myVideo" controls style="width: 100%" :src="shipp"></video>-->
                    </div>
                </div>
            </div>
        </div>
        <!--音频播放模态框-->
        <div
            class="modal fade"
            id="myModa2"
            tabindex="-1"
            role="dialog"
            aria-labelledby="myModalLabel"
            style="background:rgba(0,0,0,0.3) "
        >
            <div class="modal-dialog" role="document"  :style="yinp_style">
                <div class="modal-content">
                    <div class="modal-body" style="padding:10px;" id="yinp">
                        <div
                            aria-hidden="true"
                            v-on:click="guans2"
                            style="float: right;cursor: pointer;font-size:25px;margin-right:35px;"
                        >&times;</div>
                        <!--<video id="myaudio" controls style="width: 100%" src="__PUBLIC__/img/sy.mp4"></video>-->
                        <!-- <audio id="myaudio" :src="audio" style="width: 100%" controls="controls" controlsList="nodownload" oncontextmenu="return false"></audio> -->
                        <div style="clear: both;"></div>
                        <div style="margin-top: 0;">
                            <div id="myaudio"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--图片播放模态框-->
        <div
                class="modal fade"
                id="imgModal"
                tabindex="-1"
                role="dialog"
                aria-labelledby="myModalLabel"
                style="background:rgba(0,0,0,0.3) "
        >
            <div class="modal-dialog" role="document" style="width:505px;margin:5% auto;">
                <div class="modal-content">
                    <div class="modal-body" style="padding: 5px;">
                        <div
                                aria-hidden="true"
                                v-on:click="guanimg"
                                style="float: right;cursor: pointer;font-size:28px;"
                        >&times;</div>
                        <div style="clear: both;"></div>
                        <div style="margin-top: 0;text-align: center">
                            <img :src="imgsrc" id="myimg" style="width: 90%" alt="">
                        </div>
                        <!--<video id="myVideo" controls style="width: 100%" :src="shipp"></video>-->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // import url("../../../static/pdf/build/pdf.js");
//    var shabilz=0;
//         setInterval(function () {
//             shabilz++;
//         },1000);

//     $(window).bind('beforeunload', function(){
//       var reid= $('#reid').val()
//         $.ajax({
//             url:"{:U('jiaoan/tl')}",
//             type:"post",
//             dataType:'json',
//             data:{
//                 time:shabilz,
//                 re_id:reid
//             },
//             success:function(data){

//             }
//         });
// });

export default {
    data() {
        return {
            title: "",
            kechengname: "",
            iid: "",
            kcid: "",
            quanke1: "",
            quanke2: "",
            is_sc: 0,
            is_bk: 0,
            kecheng2: "全部课程",
            ydrs: "",
            shouc: "",
            zhengwen: "",
            re_id: "",
            shipp: "",
            ships: "",
            shipe: "",
            audios: "",
            audioe: "",
            fendata: "",
            zongdata:'',
            audio: "",
            play_auth: "",
            player: "",
            player0: "",
            jiaoid: "",
            quanke3: "",
            tokenc: "",
            classname: "",
            tuoyu:'',
            zaojiao:'',
            zengzhi:'',
            activeIndex1:'',
            activeIndex2:'',
            activeIndex3:'',
            imgsrc:'',
            ship_style:'width:850px;margin:5% auto;',
            ship_width:'817px',
            yinp_style : 'width:600px;margin: 15% auto;',
            yinp_width : '580px',
        };
    },
    methods: {
        jump: function(d) {
            this.$router.push(d);
        },
      isMobile() {
        let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
        return flag;
      },
        ke1: function(i) {
            var self = this;
            self.kcid = i;
            $.ajax({
                url: process.env.apiUrl + "saas/jiaoan/qbja",
                type: "post",
                dataType: "json",
                data: {
                    kc_id: i,
                    token: self.tokenc
                },
                success: function(data) {
                    self.quanke2 = data.data;
                }
            });
        },
        ke2: function(i) {
            var self = this;
            self.iid = i;
            $.ajax({
                url: process.env.apiUrl + "saas/jiaoan/deta",
                type: "post",
                dataType: "json",
                data: {
                    id: self.iid,
                    token: self.tokenc
                },
                success: function(data) {
                    self.iid = data.data.zong.id;
                    self.title = data.data.zong.title;
                    self.kechengname = data.data.zong.kc_name;
                    self.is_sc = data.data.zong.is_sc;
                    self.is_bk = data.data.zong.is_bk;
                    self.ydrs = data.data.zong.ydrs;
                    self.shouc = data.data.zong.sc;
                    self.zhengwen = data.data.zong.process;
                    self.re_id = data.data.zong.re_id;
                    self.audios = data.data.zong.start_vid;
                    self.audioe = data.data.zong.end_vid;
                    self.ships = data.data.zong.start_video;
                    self.shipe = data.data.zong.end_video;
                    self.zongdata = data.data.zong;
                    self.fendata = data.data.fen;
                }
            });
        },
        ke3: function(i,tag='',kcid='') {
            var self = this;
            if(tag == 1){
                self.activeIndex2 = '';
                self.activeIndex3 = '';
                self.activeIndex1 = '10-'+kcid
            }
            if(tag == 2){
                self.activeIndex1 = '';
                self.activeIndex3 = '';
                self.activeIndex2 = '11-'+kcid
            }
            if(tag == 3){
                self.activeIndex1 = '';
                self.activeIndex2 = '';
                self.activeIndex3 = '12-'+kcid
            }
            self.classname = i;
            $.ajax({
                url: process.env.apiUrl + "saas/jiaoan/get_titles",
                type: "post",
                dataType: "json",
                data: {
                    classname: i,
                    token: self.tokenc
                },
                success: function(data) {
                    self.quanke1 = data.data;
                }
            });
        },


        shez: function() {
            var self = this;
            $.ajax({
                url: process.env.apiUrl + "saas/jiaoan/swzd",
                type: "post",
                dataType: "json",
                data: {
                    id: self.iid,
                    token: self.tokenc
                },
                success: function(data) {
                    if (data == 1) {
                        self.is_sc = 1;
                    }
                }
            });
        },
        wanb: function() {
            var self = this;
            $.ajax({
                url: process.env.apiUrl + "saas/jiaoan/wcbk",
                type: "post",
                dataType: "json",
                data: {
                    id: self.iid,
                    token: self.tokenc
                },
                success: function(data) {
                    if (data == 1) {
                        self.is_bk = 1;
                    }
                }
            });
        },
        // 音乐
        yin1: function(ev) {
            var self = this;
            var el = ev.currentTarget;
            self.audio = $(el).attr("aud");

            // 				setTimeout(function() {
            // 					$('#myaudio').get(0).play()
            // 				}, 10)

            $.ajax({
                url: process.env.apiUrl + "saas/jiaoan/getplayauth",
                type: "post",
                dataType: "json",
                data: {
                    vid: self.audio,
                    token: self.tokenc
                },
                success: function(data) {
                    //判断手机还是电脑
                    if(self.isMobile()){
                        self.yinp_style = 'width:96%;margin:15% auto;'
                        self.yinp_width = '90%'
                    }else{
                        self.yinp_style = 'width:600px;margin: 15% auto;'
                        self.yinp_width = '580px'
                    }
                    self.play_auth = data.play_auth;
                    $("#myModa2").modal({
                        backdrop: "static"
                    });
                    if (self.player0) {
                        self.player0.dispose();
                    }

                    $("#myaudio").empty();
                    setTimeout(function() {
                        self.player0 = Aliplayer({
                            id: "myaudio",
                            autoplay: true,
                            width: self.yinp_width,
                            height: "100px",
                            vid: self.audio,
                            playauth: self.play_auth,
                            mediaType: "audio",
                            controlBarVisibility: "always"
                        });
                    }, 10);
                }
            });
        },
        // 视频
        ship1: function(ev) {
            var self = this;
            var el = ev.currentTarget;
            self.shipp = $(el).attr("ship");
            $.ajax({
                url: process.env.apiUrl + "saas/jiaoan/getplayauth",
                type: "post",
                dataType: "json",
                data: {
                    vid: self.shipp,
                    token: self.tokenc
                },
                success: function(data) {
                    //判断手机还是电脑
                    if(self.isMobile()){
                        self.ship_style = 'width:96%;margin:5% auto;'
                        self.ship_width = '90%'
                    }else{
                        self.ship_style = 'width:850px;margin:5% auto;'
                        self.ship_width = '817px'
                    }
                    self.play_auth = data.play_auth;
                    $("#myModal").modal({
                        backdrop: "static"
                    });

                    if (self.player) {
                        self.player.dispose();
                    }
                    $("#myVideo").empty();
                    setTimeout(function() {
                        self.player = Aliplayer({
                            id: "myVideo",
                            autoplay: true,
                            width: self.ship_width,
                            height: "460px",
                            vid: self.shipp,
                            playauth: self.play_auth
                        });
                    }, 10);
                }
            });
        },
        //查看图片
        showimg: function(src) {
            var self = this;
            self.imgsrc = src;
            $("#imgModal").modal({
                backdrop: "static"
            });
        },
        guans: function() {
            if (self.player) {
                self.player.dispose();
            }

            $("#myVideo").empty();
            $("#myModal").modal("hide");
        },
        guans2: function() {
            if (self.player0) {
                self.player0.dispose();
            }
            $("#myaudio").empty();
            $("#myModa2").modal("hide");
        },
        guanimg: function() {
            this.imgsrc = '';
            $("#imgModal").modal("hide");
        },
        get_one() {
            let self = this;
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: process.env.apiUrl + "saas/jiaoan/get_classes",
                    type: "post",
                    dataType: "json",
                    data: {
                        token: self.tokenc
                    },
                    success: function(data) {
                        // self.classname = data.data[0].classa;
                        self.classname = data.tuoyu[0].classa;
                        self.activeIndex1 = '10-'+data.tuoyu[0].kc_id;
                        self.quanke3 = data.data;
                        self.tuoyu = data.tuoyu;
                        self.zaojiao  = data.zaojiao;
                        self.zengzhi  = data.zengzhi;
                        resolve();
                    },
                    complete: function() {}
                });

            });
        },
        get_two() {
            let self = this;
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: process.env.apiUrl + "saas/jiaoan/get_titles",
                    type: "post",
                    dataType: "json",
                    data: {
                        classname: self.classname,
                        token: self.tokenc
                    },
                    success: function(data1) {
                        self.kcid = data1.data[0].kc_id;
                        self.quanke1 = data1.data;
                        resolve();
                    },
                    complete: function() {}
                });
            });
        },
        get_three() {
            let self = this;
            return new Promise((resolve, reject) => {
                $.ajax({
                    url: process.env.apiUrl + "saas/jiaoan/qbja",
                    type: "post",
                    dataType: "json",
                    data: {
                        kc_id: self.kcid,
                        token: self.tokenc
                    },
                    success: function(data2) {
                        self.jiaoid = data2.data[0].id;
                        self.quanke2 = data2.data;
                        resolve();
                    },
                    complete: function() {}
                });
            });
        },
        get_four() {
            let self = this;
            $.ajax({
                url: process.env.apiUrl + "saas/jiaoan/deta",
                type: "post",
                dataType: "json",
                data: {
                    id: self.jiaoid,
                    token: self.tokenc
                },
                success: function(data3) {
                    self.kcid = data3.data.zong.kc_id;
                    self.iid = data3.data.zong.id;
                    self.title = data3.data.zong.title;
                    self.kechengname = data3.data.zong.kc_name;
                    self.is_sc = data3.data.zong.is_sc;
                    self.is_bk = data3.data.zong.is_bk;
                    self.ydrs = data3.data.zong.ydrs;
                    self.shouc = data3.data.zong.sc;
                    self.zhengwen = data3.data.zong.process;
                    self.re_id = data3.data.zong.re_id;
                    self.ships = data3.data.zong.start_video;
                    self.shipe = data3.data.zong.end_video;
                    self.audios = data3.data.zong.start_vid;
                    self.audioe = data3.data.zong.end_vid;
                    self.zongdata = data3.data.zong;
                    self.fendata = data3.data.fen;
                }
            });
        },
        async get_request() {
            await this.get_one();
            await this.get_two();
            await this.get_three();
            this.get_four();
        },
    },
    created: function() {
        let self = this;
        self.tokenc = self.$cookies.get("token");
        self.get_request();
    }
};
</script>
<style scoped>
[v-cloak] {
    display: none;
}

* {
    margin: 0;
    padding: 0;
    font-size: 14px;
    /*font-family: "微软雅黑";*/
}

.fl {
    float: left;
}

.hang1 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.hang2 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

.hang3 {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
}

p,
label {
    margin: 0;
    padding: 0;
}

body {
    background: #ededed;
}

.btna {
    display: inline-block;
    padding: 6px 12px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;
}

.kezhuang1 {
    background: #00cce4;
    color: #fff;
}

body .dropdown-menu > li > a {
    line-height: 28px;
}

.kezhuang2 {
    background: #ff797c;
    color: #fff;
}

.dropm1,
.dropm2 {
    width: 100%;
    padding: 0;
}

.dropm1 {
    border: 1px solid #fdb06a;
    border-radius: 0 0 5px 5px;
}

.dropm2 {
    border: 1px solid #79c4c7;
    border-radius: 0 0 5px 5px;
}

.dropm1 li {
    border-bottom: 1px solid #fdb06a;
    height: 40px;
    line-height: 40px;
    text-align: center;
}

.dropm2 li {
    border-bottom: 1px solid #79c4c7;
    height: 40px;
    line-height: 40px;
    text-align: center;
}

.dropdown-menu > li > a {
    padding: 5px 20px;
}

.kelist {
    cursor: pointer;
    width: 100%;
    height: 40px;
    line-height: 40px;
    background: #fff;
    border-radius: 5px;
    text-align: center;
    color: #999;
    margin-bottom: 3px;
}

.kelist.active1 {
    color: #00cce4;
    box-shadow: 0 3px 10px #8ae3ed;
}

.kelist.active2 {
    color: #ff797c;
    box-shadow: 0 3px 10px #e9afb0;
}

.conTitle {
    font-size: 20px;
    margin-bottom: 4px;
}

.zidBtn {
    height: 30px;
    width: 104px;
    text-align: center;
    line-height: 30px;
    border-radius: 15px;
    font-size: 14px;
    color: #fff;
    border: none;
    margin: 30px 20px 0 0;
    cursor: pointer;
}

.zidg {
    background: #ff797c;
}

.zidy {
    background: #00cce4;
}

.titleListBox {
    /*border-bottom: 2px solid #fff;*/
    /*border-right: 2px solid #fff;*/
    border-radius: 10px;
    background: #fff;
}

.titleList {
    float: left;
    /*width: 40%;*/

    height: 50px;
    line-height: 50px;
    padding-left: 22px;
    cursor: pointer;
}
.titleList2 {
    float: left;
    height: 40px;
    line-height: 40px;
    padding-left: 22px;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

#myVideo {
    margin: auto;
}

/*上下的按钮*/
.neirong::-webkit-scrollbar {
    display: none;
}

/*导航条样式宽度*/
.neirong::-webkit-scrollbar-button {
    display: none;
}

/*上下的按钮*/

.neirong::-webkit-scrollbar-track {
    /*background:#FF66D5;*/
    display: none;
}

/*导航条样式颜色*/

.neirong::-webkit-scrollbar-thumb {
    display: none;
}

/*滚动条样式颜色*/
.neirong::-webkit-scrollbar-corner {
    display: none;
}

.zhengwen {
    background: #fff;
    border-radius: 10px;
    padding-left: 10px;
    margin-bottom: 4px;
}

.title11 {
    line-height: 50px;
    font-size: 18px;
}

.neirong11 {
    padding-left: 35px;
    padding-bottom: 10px;
}

.neirong {
    overflow-y: scroll;
    background: #eee;
    padding: 20px;
}

.tuiBtn {
    width: 190px;
    height: 40px;
    text-align: center;
    font-size: 20px;
    line-height: 40px;
    border-radius: 20px;
    background: #E6BE8A;
    color: #fff;
    margin: 0 auto;
    cursor: pointer;
    box-shadow: 0 3px 10px #a4a3aa;
}

.backp {
    background: #f1f1f1;
    color: #000;
}

/* 判断ipad */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) {
    /* style */
    #yinp {
        height: 120px;
    }
}

.box_video{
    width: 40%;
    height: 280px;
    background:white;
    border-radius:5px;
    /*float: left;*/
    margin-left:25%;
    /*margin-bottom:25%;*/
    margin-top: 50px;
    text-align: center;
    cursor: pointer;
}
.box_video:hover {
    box-shadow: 1px 1px 5px #cdcdcd;
}
.box_video img{
    width: 80%;
    height: 85%;
    margin-top: 10px;
}
.box_video p{
    width: 48%;
    margin-top:5px;
    margin: auto;
    /*overflow: hidden;*/
    /*text-overflow: ellipsis;*/
    white-space: nowrap;
}
.textinfo{
    display: block;
    width: 100%;
    position: relative;
}
.righttext{
    float: right;
}
.lefttext{
    float: left;
}
@media screen and (max-width: 768px) {
    .box_video{
        width:80%;
        height: 200px;
        background:white;
        border-radius:5px;
        float: left;
        margin-left: 10%;
        margin-top: 25px;
    }
    .box_video img{
        width: 80%;
        height: 150px;
        margin-top: 10px;
    }
    .cha{
        width:30px;
        height:30px;
        z-index: 99;
        position: absolute;
        top:113px;
        left: 92%;
    }

}
</style>



// WEBPACK FOOTER //
// src/pages/jiaoan/jiaoan3.vue